<template>
    <v-checkbox v-model="showCancelledServices" hide-details class="mt-0 pt-0" data-cy="cancelled-services-checkbox">
        <template v-slot:label>
            <span class="text-body-2">
                {{ $t('show_cancelled_services') }}
            </span>
        </template>
    </v-checkbox>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ShowCancelledServicesCheckbox extends Vue {
        get showCancelledServices() {
            return persistentStore.showCancelledServices
        }

        set showCancelledServices(val) {
            persistentStore.SET_SHOW_CANCELLED_SERVICES(val)
        }
    }

    export default ShowCancelledServicesCheckbox
</script>
